/* Cinch theme: product page (variant selection, gallery, quantity, add to cart) */
(function () {
  'use strict';

  var T = window.cinchTheme || {};
  var S = T.strings || {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var form = $('[data-product-form]', root);
    if (!form) return;

    var variants = [];
    try { variants = JSON.parse($('[data-product-json]', root).textContent); } catch (e) {}

    var idInput = $('[data-variant-id]', form);
    var btn = $('[data-add-to-cart]', form);
    var priceEl = $('[data-price]', root);
    var errorEl = $('[data-form-error]', form);
    var qtyInput = $('[data-pqty-input]', form);
    var busy = false;

    function selectedOptions() {
      return $$('[data-option]', form).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function showMedia(id) {
      if (!id) return;
      var items = $$('[data-media-id]', root);
      var found = items.some(function (el) { return el.getAttribute('data-media-id') === String(id); });
      if (!found) return;
      items.forEach(function (el) { el.hidden = el.getAttribute('data-media-id') !== String(id); });
      $$('[data-media-target]', root).forEach(function (b) {
        b.setAttribute('aria-current', b.getAttribute('data-media-target') === String(id) ? 'true' : 'false');
      });
    }

    function render(v) {
      if (errorEl) errorEl.hidden = true;
      if (!v) {
        btn.disabled = true;
        btn.textContent = S.unavailable || 'Unavailable';
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
      if (priceEl) {
        priceEl.innerHTML = v.compare
          ? '<div class="price price--sale"><s class="price__compare">' + v.compare + '</s> <span class="price__now">' + v.price + '</span></div>'
          : '<div class="price"><span class="price__now">' + v.price + '</span></div>';
      }
      showMedia(v.media);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-option]')) {
        render(findVariant(selectedOptions()));
      }
    });

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest && e.target.closest('[data-media-target]');
      if (thumb) { showMedia(thumb.getAttribute('data-media-target')); return; }
      var step = e.target.closest && e.target.closest('[data-pqty-step]');
      if (step && qtyInput) {
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-pqty-step'), 10));
        qtyInput.value = n;
      }
    });

    form.addEventListener('submit', function (e) {
      if (!window.CinchCart || !window.fetch) return;
      e.preventDefault();
      if (busy || btn.disabled) return;
      busy = true;
      var label = btn.textContent;
      btn.disabled = true;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var fly = window.CinchCart.flyToCart ? window.CinchCart.flyToCart(btn) : Promise.resolve();
      var add = window.CinchCart.add([{ id: parseInt(idInput.value, 10), quantity: qty }]);
      Promise.all([fly, add])
        .then(function () { window.CinchCart.afterAdd(); })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message || S.error || '';
            errorEl.hidden = false;
          }
        })
        .then(function () {
          busy = false;
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  function initAll() { $$('[data-product-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
